import React from "react";
import PropTypes from "prop-types";


function OverviewSection(props) {

  return (
    <section>
        <div className="text-section-padd">
          <div className="container">
            <div className="row mb-5">
              <div className="col-12 col-md-7">
                  {
                    props.content.overviewList.map((item, index) => (
                      <React.Fragment key={`overview-${index}`}>
                        <h5>{item.ovMainTitle}</h5>

                        {
                          item.workDuration?.map((durItem, durIndex) => (
                            <p className="work-duration-para" key={`duration-${index}-${durIndex}`}>{durItem.durItem}</p>
                          ))
                        }

                        {
                          item.ovMainText?.map((itemP, textIndex) => (
                            <p className="main-text-para" key={`text-${index}-${textIndex}`}>{itemP.oMItem}</p>
                          ))
                        }
                      </React.Fragment>
                    ))
                  }
              </div>
              <div className="col-12 col-md-2"></div>
              <div className="col-12 col-md-3">
                  <h5>My Role</h5>

                  <hr />

                  {
                    props.content.role.map((itemR, roleIndex) => (
                      <p className="main-text-para" key={`role-${roleIndex}`}>{`- ${itemR.rolItem}`}</p>
                    ))
                  }

                  {
                    props.content.recognition ? (
                      <div className="recognition-div">
                        <h5>Recognition</h5>

                        <hr />

                        {
                          props.content.recognition.map((itemRe, recogIndex) => (
                            <a href={itemRe.recogLink} target="_blank" rel="noreferrer" className="main-text-para recognition-div-link" key={`recognition-${recogIndex}`}>{`- ${itemRe.recogItem}`}</a>
                          ))
                        }
                      </div>
                    ) : (
                      null
                    )
                  }
              </div>
            </div>

            <div className="separator-hr-div">
              <hr />
            </div>
          </div>
        </div>
      </section>
  )
}

OverviewSection.propTypes = {
  content: PropTypes.shape({
    overviewList: PropTypes.arrayOf(PropTypes.shape({
      ovMainTitle: PropTypes.string,
      workDuration: PropTypes.arrayOf(PropTypes.shape({
        durItem: PropTypes.string
      })),
      ovMainText: PropTypes.arrayOf(PropTypes.shape({
        oMItem: PropTypes.string
      }))
    })).isRequired,
    role: PropTypes.arrayOf(PropTypes.shape({
      rolItem: PropTypes.string
    })).isRequired,
    recognition: PropTypes.arrayOf(PropTypes.shape({
      recogItem: PropTypes.string,
      recogLink: PropTypes.string
    }))
  }).isRequired
};

export default OverviewSection;
